import React from 'react';
import NotFoundImg from '../assets/404.png';
import SEO from '../components/SEO';

export default function NotFound() {
  return (
    <div>
      <SEO title="Page not found" description="This page does not exist." noindex />
      <img
        src={NotFoundImg}
        alt="NotFoundImg"
        width="340"
        height="296"
        className="block mx-auto"
        loading="lazy"
      />
    </div>
  )
}
